module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAD0SURBVCiRnZIxboQwEEUtopHSTzPNNC5p46tQWdor2P0eIJfY0u0egRO4cAEFJ6BFKwvRICYVK6SFLMnrnzzWf0ptsNaWWusbMw8AsADAwsyD1vpmrS3VHsaYKyLOzjmJMUrOWXLOEmMU55wg4myMub5IRCQpJTkipSREJE/ZWlsi4tw0zaG0lRFxttaWH+M4fldV9XW5XHa/sIWIVN/3RV3Xn4qZhxjj29dWYozCzIMCgGWaptNizlkAYCne3ndAQUSPtm1PC13XKSJ6FABwDyGcFkMICgDuzzl+23BvDqXUPwNYWZPz3r8k573fT27lL5H/AFRiWli6HYTeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/Ellipse 144.png
// module id = HkhT
// module chunks = 8